export { DevMenuSheet } from "./DevMenuSheet"

/** Rapid taps on the profile avatar to open {@link DevMenuSheet}. */
export const PROFILE_DEV_MENU_TAP_COUNT = 10
